import { TemplatePage } from './types';

const laborDayPage: TemplatePage = {
  header: {
    color: '#B0E1FF',
    icon: 'images/video-templates/labor-day.jpg',
    title: 'Labor Day Video Templates Collection',
    title_meta: '10+ Customizable and Free Labor Day Video Templates',
    description_meta:
      'Make the most out of your end-of-summer marketing campaign with Wave.video’s 10+ customizable Labor ' +
      'Day video templates.',
    description:
      'Make the most out of your end-of-summer marketing campaign with these customizable Labor Day video ' +
      'templates. Easily create attention-grabbing videos that your audience will love.'
  },
  footer: {
    category: 'Labor Day',
    description:
      'With Wave.video’s selection of Labor Day video templates, you will save lots of time and effort when ' +
      'creating compelling marketing videos for your website, social media, blog, or email newsletter. All ' +
      'templates are free and easy to edit to adhere to your brand’s style.'
  },
  content: [
    {
      type: 'templates',
      title: 'Labor Day Video Templates',
      search: {
        category: '/Holidays & Occasions/Labor Day'
      }
    },
    {
      type: 'stocks',
      title: 'Labor Day',
      search: {
        name: 'labor day'
      }
    },
    { type: 'calendar' }
  ]
};

export default laborDayPage;
